import React from 'react';
import { Control, Controller, FieldValues } from 'react-hook-form';
import { CheckboxFieldType } from '@/type';
import CheckboxInput from '@components/common/input/CheckboxInput';

interface CheckboxProps<TFieldValues extends FieldValues = FieldValues> {
  control: Control<TFieldValues>;
  checkboxField: CheckboxFieldType;
}

const CheckboxController = <TFieldValues extends FieldValues = FieldValues>({
  control,
  checkboxField,
}: CheckboxProps<TFieldValues>) => {
  return (
    <Controller
      name={checkboxField.name as any}
      control={control}
      defaultValue={false as any}
      render={({ field }) => (
        <CheckboxInput field={field} checkboxField={checkboxField} />
      )}
    />
  );
};

export default CheckboxController;
